import styled, { css } from 'styled-components'

import { colors } from '../../constants/colors'
import { zIndex } from '../../constants/zIndex'
import { media } from '../../utils/media'

export const Cinema = styled.div<{
  fadeIn?: boolean
  fadeDelay?: number
}>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: ${colors.black};
  opacity: ${({ fadeIn }) => (fadeIn ? 1 : 0)};
  transition: ${({ fadeDelay = 400 }) => `opacity ${fadeDelay}ms`};
  z-index: ${zIndex.newLayer};
`

export const VideoWrapper = styled.div`
  > iframe {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    top: 0;
    bottom: 0;
  }
`
export const CloseButton = styled.button`
  position: absolute;
  z-index: ${zIndex.above};
  cursor: pointer;
  background: ${colors.white};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  top: 50px;
  right: 50px;

  ${media.md(css`
    top: ${({ theme }) => theme.spacing[4]};
    right: ${({ theme }) => theme.spacing[4]};
    width: ${({ theme }) => theme.spacing[3]};
    height: ${({ theme }) => theme.spacing[3]};
  `)}

  @media (max-width: 850px) and (max-height: 450px) and (orientation: landscape) {
    top: 20px;
    right: 20px;
  }
`

export const ProgressBarWrap = styled.div`
  z-index: ${zIndex.above};
  height: 3px;
  position: absolute;
  left: 2rem;
  right: 2rem;
  bottom: 2rem;
  background: white;
  overflow: hidden;

  ${media.md(css`
    left: ${({ theme }) => theme.spacing[5]};
    right: ${({ theme }) => theme.spacing[5]};
    bottom: ${({ theme }) => theme.spacing[4]};
  `)}

  @media (max-width: 850px) and (max-height: 450px) and (orientation: landscape) {
    bottom: 2rem;
  }
`

export const ProgressBar = styled.div`
  background: ${colors.softBlue};
  bottom: 0;
  display: block;
  left: 0;
  position: absolute;
  top: 0;
  transform: translateX(-100%);
  transition: transform 200ms linear;
  width: 100%;
`

export const Icon = () => (
  <>
    <TopLine />
    <BottomLine />
  </>
)

const Line = styled.div`
  background: #454647;
  height: 2px;
  margin: auto;
  width: 14px;
`

const TopLine = styled(Line)`
  transform: translateY(1px) rotateZ(-45deg);
`

const BottomLine = styled(Line)`
  transform: translateY(-1px) rotateZ(45deg);
`
